import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import UpdateIcon from '@material-ui/icons/Update';
import '../../Americo/steps/Status.scss';

export default function StatusStepCard(props){

  const { active, stepNumber, stepTitle, stepStatusLabel, showTimeIcon } = props;

  const activeColor = active ? '#333333' : '#999999';

  const useStyles = makeStyles(theme => ({
    statusSection: {
      borderColor: activeColor,
      color: activeColor,
    },
    time: {
      backgroundColor: activeColor,
    },
    circleNumber: {
      borderColor: activeColor,
    }
  }));

  const classes = useStyles();

  return (
    <div className={`${classes.statusSection} statusSection`}>
      <div>
        <div className={`${classes.circleNumber} circleNumber`}>
          {stepNumber}
        </div>

        <p className="stepTitle">{stepTitle}</p>
      </div>

      <span className={`${classes.time} time`}>
      {showTimeIcon !== false && <UpdateIcon />} {stepStatusLabel}
      </span>

      {active &&
        <div className="statusStepContainer">
          {props.children}
        </div>
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Status/StatusStepCard.js